import React from 'react'

function About() {
    return (
        <section id="about" className="about">
        <div className="container">
            <div className="section-title" data-aos="fade-up">
                <h2>About Us</h2>
            </div>

            <div className="row content">
                <div className="col-lg-6" data-aos="fade-up" data-aos-delay="150">
                    <p className="text-justify">
                        A journey that started off with humble beginnings of website design and app development. Now, I am offering an array of services to meet the requirements of diverse sectors of businesses in Pakistan and overseas.
                    </p>
                    <ul>
                        <li><i className="ri-check-double-line"></i> Cross-Platform Compatibility</li>
                        <li><i className="ri-check-double-line"></i> Responsive Design</li>
                        <li><i className="ri-check-double-line"></i> Efficient Speed without Redirecting</li>
                    </ul>
                </div>
                <div className="col-lg-6 pt-4 pt-lg-0" data-aos="fade-up" data-aos-delay="300">
                    <p className="text-justify">
                        I offer professional services in Android and iOS app development, website design and development, graphic design, domain registration, web hosting, software quality assurance, CRM systems, landing pages, responsive sites, and full software development, including debugging and issue resolution.
                    </p>
                </div>
            </div>
        </div>
    </section>
    )
}

export default About